import { useTranslation } from "@coworker/locales";
import { useCustomAllSelectOption } from "../../shared/filters/utils/useAllSelectOption";
import {
  FilterType,
  FilterValue,
  InputType,
  RowVisibility,
  SelectFilter,
} from "../../shared/filters/types/filter";
import { TASK_TYPE_ID } from "./useTaskTypeFilter";

const GROUP_BY_ID = "groupBy";

const ADDON_TASK_TYPES = ["pickAndRefill", "refill"];

export function useGroupByFilter(filterValues: FilterValue[]): SelectFilter {
  const { t } = useTranslation();
  const defaultValue = { filterId: GROUP_BY_ID, value: "" };

  const enabled = filterValues.some(
    (filter) =>
      filter.filterId === TASK_TYPE_ID &&
      ADDON_TASK_TYPES.includes(filter.value as string)
  );

  return useCustomAllSelectOption(
    {
      inputType: InputType.Select,
      filterType: FilterType.Filter,
      id: GROUP_BY_ID,
      title: t("groupByTitleString"),
      options: [
        {
          value: "hfbPickup",
          title: t("hfbPickupLocationString"),
          dependsOnFilterId: TASK_TYPE_ID,
        },
        {
          value: "hfbRefill",
          title: t("hfbRefillLocationString"),
          dependsOnFilterId: TASK_TYPE_ID,
        },
      ],
      enabled,
      defaultValue,
      rowVisibility: RowVisibility.PillOnly,
    },
    t("noGroupingString")
  );
}
